import { CompanyRepository } from "../../repositories/CompanyRepository";

/**
 * Delete Company Use Case
 * Soft deletes a company
 */
export class DeleteCompanyUseCase {
  constructor(private repository: CompanyRepository) {}

  async execute(companyId: number): Promise<void> {
    if (!companyId || companyId <= 0) {
      throw new Error("Valid company ID is required");
    }

    await this.repository.deleteCompany(companyId);
  }
}

